import React from 'react';
import { Modal, Button, Icon, Header } from 'semantic-ui-react';

interface QuizExitConfirmModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const QuizExitConfirmModal: React.FC<QuizExitConfirmModalProps> = ({
  open,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal open={open} size="small" onClose={onCancel}>
      <Header icon="exclamation triangle" content="Cancelar Tentativa de Questionário" />
      <Modal.Content>
        <p>
          Você tem uma tentativa de questionário em andamento. Se você sair agora, 
          sua tentativa será cancelada e você perderá todo o progresso.
        </p>
        <p>
          <strong>Deseja realmente cancelar e sair?</strong>
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCancel} color="grey">
          <Icon name="arrow left" />
          Continuar Questionário
        </Button>
        <Button onClick={onConfirm} negative>
          <Icon name="times" />
          Cancelar Tentativa
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default QuizExitConfirmModal;

